module.exports = __webpack_public_path__ + "img/SUPPORT.f007189c.svg";